import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable()
export class FormatDateService {
    public formatDateOnly(date: Date): string {
        const localDate = DateTime.fromJSDate(date);
        const mstDate = localDate.setZone('America/Denver');

        const month = mstDate.toFormat('MM').padStart(2, '0');
        const day = mstDate.toFormat('dd').padStart(2, '0');
        const year = mstDate.toFormat('yyyy');

        return `${month}/${day}/${year}`;
    }

    public formatDateTime(date: Date): string {
        const localDate = DateTime.fromJSDate(date);
        const mstDate = localDate.setZone('America/Denver');

        const month = mstDate.toFormat('MM').padStart(2, '0');
        const day = mstDate.toFormat('dd').padStart(2, '0');
        const year = mstDate.toFormat('yyyy');
        const hours = mstDate.toFormat('HH').padStart(2, '0');
        const minutes = mstDate.toFormat('mm').padStart(2, '0');
        const seconds = mstDate.toFormat('ss').padStart(2, '0');

        return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
    }

    public formatDateToUSFromIsoString(isoDateString: string): string {
        let date = new Date(isoDateString);
        if (isNaN(date.getTime())) return '';
        let pad = (n: number) => n.toString().padStart(2, '0');
        let month = pad(date.getMonth() + 1);
        let day = pad(date.getDate());
        let year = date.getFullYear();

        return `${month}/${day}/${year}`;
    }
}
